<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Status:"
    id="selectStatusPlanilha"
    placeholder="Selecione o status"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectPlanilhaStatus',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [
        {value: 'SUCESSO', text: 'SUCESSO'},
        {value: 'PROCESSANDO', text: 'PROCESSANDO'},
        {value: 'AGUARDANDO_PROCESAMENTO', text: 'AGUARDANDO PROCESSAMENTO'},
        {value: 'FALHA', text: 'FALHA'},
        {value: 'CANCELADO', text: 'CANCELADO'}
      ],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectPlanilhaStatus.vue